import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { baseUrl } from '../providers/AppDataProvider';

export interface PredictionEvent {
  id?: number;
  slug?: string;
  title?: string;
  icon?: string;
  category?: string;
}

export interface PredictionPosition {
  assetId: string;
  openQty: string;
  costBasis: string;
  realizedPnl: string;
  totalFees: string;
  lastEventAt: string;
  closedAt: string | null;
  event?: PredictionEvent;
}

export interface PredictionTradeItem {
  tradeId: string;
  assetId: string;
  marketId: string;
  kind: string;
  qty: string;
  usdc: string;
  feeUsdc: string;
  realizedPnlDelta: string;
  occurredAt: string;
  source: string;
  event?: PredictionEvent;
}

export interface PredictionTradeHistory {
  items: PredictionTradeItem[];
  pageInfo: {
    nextCursor: string | null;
    hasNextPage: boolean;
  };
}

async function getAuthHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

export async function fetchPredictionPositions(userId: string): Promise<PredictionPosition[]> {
  const headers = await getAuthHeaders();
  const response = await axios.get<PredictionPosition[]>(
    `${baseUrl}/prediction/users/${userId}/positions`,
    { headers }
  );
  return response.data;
}

export async function fetchPredictionTradeHistory(
  userId: string,
  limit = 50,
  cursor?: string
): Promise<PredictionTradeHistory> {
  const headers = await getAuthHeaders();
  const params: Record<string, any> = { limit };
  if (cursor) params.cursor = cursor;
  const response = await axios.get<PredictionTradeHistory>(
    `${baseUrl}/prediction/users/${userId}/trade-history`,
    { headers, params }
  );
  return response.data;
}
